// apps/conext-ventas/src/components/contacts/RecipientPickerModal.jsx
import React from "react";
import { X, Phone, User } from "lucide-react";

/**
 * Mini-modal para elegir a qué número enviar una comunicación.
 * Aparece cuando el lead tiene persona de contacto con teléfono propio.
 */
export default function RecipientPickerModal({
  open,
  onClose,
  mainPhone,
  personaName,
  personaPhone,
  onSelect,
}) {
  if (!open) return null;

  const handleSelect = (phone) => {
    if (!phone) { onClose(); return; }
    onSelect(phone);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[10100] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-3xl p-6 w-full max-w-xs mx-4 shadow-2xl">
        <div className="flex items-start justify-between mb-5">
          <div>
            <h2 className="text-base font-bold text-slate-900">¿A quién enviamos?</h2>
            <p className="text-xs text-slate-400 mt-0.5">Elige el destinatario</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-xl text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="flex flex-col gap-3">
          {/* Opción 1: Teléfono principal */}
          <button
            type="button"
            onClick={() => handleSelect(mainPhone)}
            className="flex items-center gap-3 w-full p-4 rounded-2xl border border-slate-200 bg-slate-50 hover:border-red-300 hover:bg-red-50/50 transition-all text-left"
          >
            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-red-100 flex items-center justify-center">
              <Phone className="w-4 h-4 text-red-600" />
            </div>
            <div>
              <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Teléfono principal</p>
              <p className="text-sm font-semibold text-slate-700">{mainPhone}</p>
            </div>
          </button>

          {/* Opción 2: Persona de contacto */}
          <button
            type="button"
            onClick={() => handleSelect(personaPhone)}
            className="flex items-center gap-3 w-full p-4 rounded-2xl border border-violet-200 bg-violet-50/50 hover:border-violet-400 hover:bg-violet-50 transition-all text-left"
          >
            <div className="flex-shrink-0 w-9 h-9 rounded-xl bg-violet-100 flex items-center justify-center">
              <User className="w-4 h-4 text-violet-600" />
            </div>
            <div>
              <p className="text-xs font-bold text-violet-500 uppercase tracking-wider">Persona de contacto</p>
              <p className="text-sm font-semibold text-slate-700">{personaName}</p>
              <p className="text-xs text-slate-400">{personaPhone}</p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
